import { post } from "../utils/http";
export default {
  async checkSlot(param) {
    return await post(
      `${process.env.WAITING_ROOM_API_BASE_URL}/check-slot`,
      param,
      true
    );
  },
  async getWaitingInfo(param) {
    return await post(
      `${process.env.WAITING_ROOM_API_BASE_URL}/get-wating-info`,
      param,
      true
    );
  },
  async removeOnlineUser(param) {
    return await post(
      `${process.env.WAITING_ROOM_API_BASE_URL}/remove-slot`,
      param,
      true
    );
  },
};
